import React, { PureComponent } from 'react'
import DesignerBody from '../components/DesignerBody.js'
import { Route, Switch } from 'react-router-dom'
import FabricsPage from '../components/FabricsPage/FabricsPage.js'
import Kit from '../components/Kit.js'

class StandalonePagesRouter extends PureComponent {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <DesignerBody>
        <Switch>
          <Route path={'/fabrics'}>
            <FabricsPage />
          </Route>
          <Route path={'/kit'}>
            <Kit />
          </Route>
        </Switch>
      </DesignerBody>
    )
  }
}

export default StandalonePagesRouter
